import { formatNumber } from 'utils/numberFormat';

interface ProductInfoPriceProps {
  unit: Conversation.Product['unit'];
  originalHighPrice: Conversation.Product['originalHighPrice'];
  skuLowPrice: Conversation.Product['skuLowPrice'];
  skuHighPrice: Conversation.Product['skuHighPrice'];
}

export const ProductInfoPrice = (props: ProductInfoPriceProps) => {
  const { unit, originalHighPrice, skuLowPrice, skuHighPrice } = props;

  const isDiffPrice = originalHighPrice !== skuHighPrice;

  let priceRange;
  if (skuLowPrice === skuHighPrice) {
    if (skuLowPrice === 0) {
      priceRange = `${unit} ${formatNumber(originalHighPrice, '0,0.00')}`;
    } else {
      priceRange = `${unit} ${formatNumber(skuLowPrice, '0,0.00')}`;
    }
  } else {
    priceRange = `${unit} ${formatNumber(skuLowPrice, '0,0.00')} - ${unit} ${formatNumber(
      skuHighPrice,
      '0,0.00',
    )}`;
  }

  return (
    <div className="mt-[0.5] text-[12px] text-[var(--fett-text-primary)]">
      <span>{priceRange}</span>
      {isDiffPrice && (
        <span className="text-[var(--fett-text-tertiary)] line-through ml-1">
          {`${unit} ${formatNumber(originalHighPrice, '0,0.00')}`}
        </span>
      )}
    </div>
  );
};
